import { CustomerView, StoredCustomer } from '../domain/customer.model';

/**
 * Cliente guardado en el navegador (marcador de «hay sesión»; las cookies reales son httpOnly).
 * Clave heredada del flujo anterior para que el checkout y el pedido sigan leyéndola.
 *
 * Un INVITADO va a `sessionStorage` (muere con el navegador, igual que su cookie); una cuenta real a `localStorage`.
 * Nunca queda en los dos.
 */
export const CUSTOMER_STORAGE_KEY = 'prosell_storefront_user';

function almacenes(): Storage[] {
  const lista: Storage[] = [];
  try {
    lista.push(sessionStorage);
  } catch {
    // sessionStorage no disponible (navegación privada, cuota): se sigue con el resto.
  }
  try {
    lista.push(localStorage);
  } catch {
    // ver arriba.
  }
  return lista;
}

/** Añade `isGuest` y, en cuentas reales sin correo de contacto, usa el de la cuenta (lo lee el checkout). */
export function toStoredCustomer(customer: CustomerView): StoredCustomer {
  const isGuest = customer.profileType === 'GUEST';
  return { ...customer, isGuest, contactEmail: customer.contactEmail ?? (isGuest ? null : customer.email) };
}

export function readStoredCustomer(): StoredCustomer | null {
  for (const almacen of almacenes()) {
    try {
      const raw = almacen.getItem(CUSTOMER_STORAGE_KEY);
      if (raw) {
        return JSON.parse(raw) as StoredCustomer;
      }
    } catch {
      // valor corrupto o almacén inaccesible: se prueba el siguiente.
    }
  }
  return null;
}

export function clearStoredCustomer(): void {
  for (const almacen of almacenes()) {
    try {
      almacen.removeItem(CUSTOMER_STORAGE_KEY);
    } catch {
      // nada que borrar.
    }
  }
}

export function writeStoredCustomer(customer: StoredCustomer | null): void {
  clearStoredCustomer();
  if (!customer) {
    return;
  }
  try {
    (customer.isGuest ? sessionStorage : localStorage).setItem(CUSTOMER_STORAGE_KEY, JSON.stringify(customer));
  } catch {
    // almacén no disponible: la sesión sigue en memoria.
  }
}

/** Refleja el correo que el invitado acaba de dejar, para que el resto de la tienda lo vea sin otra petición. */
export function updateStoredContactEmail(email: string): void {
  const actual = readStoredCustomer();
  if (actual) {
    writeStoredCustomer({ ...actual, contactEmail: email });
  }
}
